export const messages = {
  en: {
    allocationStorehouseDetail: {
      applyInfo: 'Application Information',
      print: 'Print',
      back: 'Back',
      applicant: 'Applicant:',
      applyTime: 'Application Time:',
      type: 'Type:',
      status: 'Status:',
      applyRemark: 'Application Remark:',
      allocationGoods: 'Allocation Goods',
      goodsId: 'Goods ID',
      goodsType: 'Goods Type',
      goodsName: 'Goods Name',
      goodsSpec: 'Goods Specification',
      goodsCode: 'Goods Code',
      fixedGoods: 'Fixed Goods',
      transferredWarehouse: 'Transferred Warehouse',
      returnPerson: 'Return Person',
      targetWarehouse: 'Target Warehouse',
      originalStock: 'Original Stock',
      allocationQuantity: 'Allocation Quantity',
      workflow: 'Workflow Process',
      serialNumber: 'No.',
      handler: 'Handler',
      processTime: 'Process Time',
      timeConsuming: 'Time Consuming',
      opinion: 'Opinion'
    },
    
  },
  zh: {
    allocationStorehouseDetail: {
      applyInfo: '申请信息',
      print: '打印',
      back: '返回',
      applicant: '申请人：',
      applyTime: '申请时间：',
      type: '类型：',
      status: '状态：',
      applyRemark: '申请说明：',
      allocationGoods: '调拨物品',
      goodsId: '物品ID',
      goodsType: '物品类型',
      goodsName: '物品名称',
      goodsSpec: '物品规格',
      goodsCode: '物品编码',
      fixedGoods: '固定物品',
      transferredWarehouse: '被调仓库',
      returnPerson: '退还人',
      targetWarehouse: '目标仓库',
      originalStock: '原库存',
      allocationQuantity: '调拨数量',
      workflow: '工单流转',
      serialNumber: '序号',
      handler: '处理人',
      processTime: '处理时间',
      timeConsuming: '耗时',
      opinion: '意见'
    },
   
  }
}